import {
  RecommendationAction as GqlRecommendationAction,
  PricingRecommendationActionInput,
} from '@/types';
import {
  RecommendationAction as LocalRecommendationAction,
  RecommendationActionEntry,
} from '@/experiences/sales-portal/domain/pricing-agent/blocs/stores/recommendation-actions-store-types';

const toGqlAction = (
  action: LocalRecommendationAction,
): GqlRecommendationAction => {
  switch (action) {
    case LocalRecommendationAction.Accepted:
      return GqlRecommendationAction.Accept;
    case LocalRecommendationAction.Overridden:
      return GqlRecommendationAction.Override;
    case LocalRecommendationAction.Rejected:
      return GqlRecommendationAction.Reject;
  }
};

export const toActionInput = (
  entry: RecommendationActionEntry,
): PricingRecommendationActionInput => {
  const isOverride = entry.action === LocalRecommendationAction.Overridden;
  return {
    action: toGqlAction(entry.action),
    new_gross_profit_in_percentage: isOverride
      ? entry.overrideGrossProfitInPercentage?.toString()
      : undefined,
    new_price_in_micros: isOverride ? entry.overridePriceInMicros : undefined,
    reason:
      entry.action === LocalRecommendationAction.Rejected &&
      entry.rejectionReason
        ? {
            note: entry.rejectionReason.note,
            tags: entry.rejectionReason.tags,
          }
        : undefined,
    recommendation_id: entry.recommendationUUID,
  };
};
